import { deckPassiveStartingEffect } from './authoring/index.js';
import { content } from './content/index.js';
import { isDeckPassiveId } from './deck-passive-id.js';
function passiveMap(source) {
    return 'deckPassives' in source ? source.deckPassives : source;
}
function compareIds(left, right) {
    return left < right ? -1 : left > right ? 1 : 0;
}
export function getDeckPassiveDefinition(passiveId, source = content) {
    return passiveMap(source).get(passiveId);
}
export function listAvailableDeckPassives(source = content) {
    return Object.freeze([...passiveMap(source).values()]
        .filter((passive) => passive.role === 'available')
        .sort((left, right) => compareIds(left.id, right.id)));
}
export function validateDeckPassiveSelection(passiveId, source = content) {
    if (passiveId === null)
        return Object.freeze({ valid: true, passive: null });
    if (!isDeckPassiveId(passiveId)) {
        return Object.freeze({ valid: false, code: 'UNKNOWN_PASSIVE', passiveId: String(passiveId) });
    }
    const passive = passiveMap(source).get(passiveId);
    if (passive === undefined) {
        return Object.freeze({ valid: false, code: 'UNKNOWN_PASSIVE', passiveId });
    }
    if (passive.role !== 'available') {
        return Object.freeze({
            valid: false,
            code: 'PASSIVE_NOT_AVAILABLE',
            passiveId,
            role: passive.role,
        });
    }
    return Object.freeze({ valid: true, passive });
}
export function resolveAvailableDeckPassive(passiveId, source = content) {
    const validation = validateDeckPassiveSelection(passiveId, source);
    if (validation.valid)
        return validation.passive;
    if (validation.code === 'UNKNOWN_PASSIVE') {
        throw new Error(`deck passive "${validation.passiveId}" неизвестна`);
    }
    throw new Error(`deck passive "${validation.passiveId}" недоступна (role "${validation.role}")`);
}
export function resolveDeckPassiveStartingEffect(passiveId, source = content) {
    const passive = resolveAvailableDeckPassive(passiveId, source);
    return passive === null ? null : deckPassiveStartingEffect(passive);
}
//# sourceMappingURL=deck-passive-catalog.js.map